<template>
  <h3 class="font-semibold leading-6 mb-4 text-base mt-0">
    {{ title }}
  </h3>
  <div class="flex justify-between items-center">
    <span class="more-options__toggle__label">{{ content }}</span>
    <ToggleField
      :model-value="modelValue"
      class="ml-2"
      data-test-id="more__filters-flexible-cancellation-filter"
      @update:modelValue="$emit('update:modelValue', $event)"
    />
  </div>
</template>
<script>
import ToggleField from '@/components/Ui/Forms/ToggleField.vue';

export default {
  name: 'SwitchFilterSection',
  emits: ['update:modelValue'],
  components: {
    ToggleField,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
    modelValue: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
